import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CircleDollarSign, UserRoundPen, FileText, LogOut } from 'lucide-react';
import './navbar.css';
import logo from '../images/FAAMS__FAAMS_Goldlogo.png';
import profile_pic from '../images/profile-pic.png';

const Navbar = ({ user, onLogout }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';
  const navigate = useNavigate();
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);

  const toggleAboutDropdown = () => {
    setAboutDropdownOpen(prev => !prev);
  };
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const closeMobileMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  const handleLogo = () => {
    navigate('/');
  }

  const loginFunction = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
    navigate('/login')
  }

  useEffect(() => {
    const navbar = document.getElementById('navbar' || 'black-navbar');
    let lastScrollTop = 0;

    const handleScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop) {
        navbar.style.top = '-100px';
      } else {
        navbar.style.top = '0';
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav id = 'navbar' className={`navbar ${isAboutPage ? 'black-navbar' : ''}`}>
      <div className="navbar-inner">
        <div className="logo">
          <img src={logo} alt="logo" onClick={() => { handleLogo(); closeMobileMenu(); }}/>
        </div>

        <div className={`nav-links-container ${menuOpen ? 'open' : ''}`}>
          <ul className="navbar-links">
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li className="about-us-dropdown">
              <Link to="/about" onClick={closeMobileMenu}>About Us</Link>
              <ul className="about-us-dropdown-menu">
                <li><Link to="/advisory-board" onClick={closeMobileMenu}>Advisory Board</Link></li>
              </ul>
            </li>
            <li><Link to="/faams-scholarship" onClick={closeMobileMenu}>FAAMS Scholarship</Link></li>
            <li><Link to="/donate" onClick={closeMobileMenu}>Donations</Link></li>
            <li><Link to="/blog" onClick={closeMobileMenu}>Blog</Link></li>
            <li><Link to="/scholarships" onClick={closeMobileMenu}>Additional Scholarships</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
          </ul>
        </div>

        <div className="right-side">
          <div className="hamburger" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          {!user && (
            <div className='login-text'>
              <button className='nav-login' onClick={loginFunction}>Login</button>
          
          </div>
          )}
          {user && (
            <div className="profile-container">
              <img
                src={profile_pic}
                alt="Profile"
                className="profile-picture"
                onClick={toggleDropdown}
              />
              {dropdownOpen && (
                <div className="dropdown-menu">
                  <Link to="/profile" className="dropdown-item" onClick={toggleDropdown}>
                    <UserRoundPen size={18} />
                    Profile
                  </Link>
                  <Link to="/applications" className="dropdown-item" onClick={toggleDropdown}>
                    <FileText size={18} />
                    Applications
                  </Link>
                  <button className="dropdown-item logout" onClick={() => { onLogout(); toggleDropdown(); }}>
                    <LogOut size={18} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
